module.exports = __webpack_public_path__ + "static/media/SelectFinicityorManual.4b5b91eb.svg";